<mat-card appearance="outlined" style="overflow: auto; max-height: 80vh;">
	<mat-card-content class="no-title">
		<app-time-app-work-supply-product-list (productSelected)="onProductSelected($event)" [lightweight]="true"></app-time-app-work-supply-product-list>
	</mat-card-content>
	
	<mat-dialog-actions style="flex-wrap: nowrap">
		<button (click)="save()" [disabled]="!(selectedProductNumber | async)" [innerText]="'MAIN_APP_SERVICE_APP.artikelErfassen' | translate" class="confirm" mat-stroked-button></button>
		<button [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate" class="cancel" mat-dialog-close mat-stroked-button></button>
	</mat-dialog-actions>
</mat-card>